<template>
    <div class="bulk-update">
        <div class="bulk-update-select">
            <div class="customer-search-results col-xs-6">
                <h4>Choose {{objectType}} To Update</h4>
                <div class="customer-search-results-table">
                    <sortable-table :data="unselectedList" :columns="columns" :action="selectAction" v-on:action:select="select" />
                </div>
                <div class="bulk-update-actions">
                    <button class="btn btn-primary" v-on:click="selectAll()" :disabled="allSelected">Select All</button>
                    <button class="btn btn-primary" v-on:click="selectNone()" :disabled="!hasSelected">Select None</button>
                </div>
            </div>
            <div class="customer-search-results col-xs-6">
                <h4>Update These {{objectType}}</h4>
                <div class="customer-search-results-table">
                    <sortable-table :data="selectedList" :columns="columns" :action="unselectAction" v-on:action:unselect="unselect" />
                </div>
                <div class="bulk-update-actions">
                    <button class="btn btn-primary" :disabled="!hasSelected" v-for="action in options.actions" v-on:click="loadForm(action)">{{action.label}}</button>
                </div>
            </div>
        </div>
        <div class="bulk-update-modal-wrapper" v-show="actionFormVisible">
            <div class="bulk-update-modal-mask" v-on:click="closeForm()"></div>
            <div class="bulk-update-modal">
                <div class="bulk-update-form-loading loading" v-if="!actionFormLoaded"></div>
                <div clsss="bulk-update-form" v-if="actionFormLoaded">
                    <button v-on:click="closeForm()" class="close" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                    <h3>{{actionFormTitle}}</h3>
                    <p>({{selected.length}} Selected)</p>
                    <form @submit="submitForm">
                        <formly-form-flex :form="actionForm" :fields="actionFormFields" :model="actionFormModel" v-if="actionFormData" ref="bulkActionForm"></formly-form-flex>
                        <div class="message-container alert alert-info" v-if="hasMessage" v-html="message"></div>
                        <div class="error-container alert alert-danger" v-if="hasError" v-html="error"></div>
                        <div class="file-container" v-if="hasFile" v-html="file"></div>
                        <div>
                            <div class="form-group col-xs-6">
                                <toggle-switch v-model="clearOnSubmit" v-if="actionFormData">Hide Selected from Results</toggle-switch>
                            </div>
                            <div class="col-xs-6">
                                <input class="form-submit btn btn-primary pull-right" type="submit" v-if="actionFormData" value="Finish" />
                                <button class="btn btn-default pull-right" v-on:click="closeForm()">{{closeLabel}}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import querystring from 'querystring'
    import SortableTable from '@/components/SortableTable'
    import ToggleSwitch from '@/components/ToggleSwitch'

    export default {
        props: ['data', 'columns', 'options'],
        name: 'BulkUpdate',
        components: {SortableTable, ToggleSwitch},
        data () {
            return {
                content: false,
                results: null,
                formOpen: false,
                actionForm: {},
                actionFormSubmitApi: null,
                actionFormTitle: 'Action Form',
                actionFormOperation: null,
                actionFormFields: null,
                actionFormModel: null,
                actionFormLoaded: false,
                actionFormError: null,
                actionFormMessage: null,
                actionFormFile: null,
                actionFormSuccess: null,
                clearOnSubmit: true,
                selectAction: 'action:select',
                unselectAction: 'action:unselect',
                selected: []
            }
        },
        computed: {
            objectType () {
                return this.options ? this.options.objectType || 'Items' : 'Items'
            },
            closeLabel () {
                return this.actionFormData ? 'Cancel' : 'Close'
            },
            selectedList () {
                const self = this
                return this.data.filter(function (element) {
                    return self.selected.indexOf(element.id) >= 0
                })
            },
            unselectedList () {
                const self = this
                return this.data.filter(function (element) {
                    return self.selected.indexOf(element.id) < 0
                })
            },
            hasSelected () {
                return this.selected.length > 0
            },
            allSelected () {
                return this.selected.length === this.data.length
            },
            hasError () {
                return this.actionFormError !== undefined && this.actionFormError !== null
            },
            error () {
                let errors = Array.isArray(this.actionFormError) ? this.actionFormError : [this.actionFormError || 'An Unknown Error Has Occurred']
                return errors.join('<br/>')
            },
            hasMessage () {
                return this.actionFormMessage !== undefined && this.actionFormMessage !== null
            },
            message () {
                let messages = Array.isArray(this.actionFormMessage) ? this.actionFormMessage : [this.actionFormMessage]
                return messages.join('<br/>')
            },
            hasFile () {
                return this.actionFormFile !== undefined && this.actionFormFile !== null
            },
            file () {
                if (this.hasFile) {
                    let file = '<a href="' +
                        (this.actionFormFile['link'] || '#') +
                        '" download="' +
                        (this.actionFormFile['fileName'] || '#') +
                        '"><img src="' +
                        (this.actionFormFile['icon'] || '#') +
                        '" /> ' +
                        (this.actionFormFile['linkText'] || 'Download') +
                        '</a>'

                    return file
                } else {
                    return ''
                }
            },
            actionFormVisible () {
                return this.formOpen
            },
            actionFormData () {
                return this.actionFormFields !== null && this.actionFormFields.length > 0
            },
            actionFormHasError () {
                return this.actionFormError !== null
            }
        },
        methods: {
            select (event) {
                if (this.selected.indexOf(event) < 0) {
                    this.selected.push(event)
                }
            },
            unselect (event) {
                let index = this.selected.indexOf(event)

                if (index >= 0) {
                    this.selected.splice(index, 1)
                }
            },
            selectAll () {
                this.selected = []
                for (let item of this.data) {
                    this.selected.push(item.id)
                }
            },
            selectNone () {
                this.selected = []
            },
            setFormData (data, action) {
                this.actionFormTitle = data.title || this.actionFormTitle || action.label
                this.actionFormOperation = data.operation || this.actionFormOperation || action.label
                this.actionFormModel = data.model || this.actionFormModel || {}
                this.actionFormFields = data.fields || this.actionFormFields || []
                this.actionFormError = data.error || null
                this.actionFormMessage = data.message || null
                this.actionFormFile = data.file || null
                this.actionFormSuccess = data.successful || []
                this.actionFormSubmitApi = data.submitApi || this.actionFormSubmitApi
                this.actionFormLoaded = true
            },
            loadForm (action) {
                const self = this
                this.actionForm = {}
                this.actionFormLoaded = false
                this.formOpen = true

                if (action.loadApi !== undefined && action.loadApi !== null) {
                    return axios.post(action.loadApi, querystring.stringify({operation: action.operation, objects: JSON.stringify(this.selected)}), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                        .then(function (response) {
                            if (response.data === undefined || response.data === null) {
                                response.data = {}
                            }

                            if (!response.data.result) {
                                response.data.error = response.data.error || response.data.message || 'An unknown error has occurred'
                                if (response.data.error === response.data.message) {
                                    response.data.message = null
                                }
                            }

                            self.setFormData(response.data, action)
                        })
                        .catch((error) => {
                            if (error instanceof Error) {
                                self.setFormData({error: error.message || 'An unknown error has occurred'}, action)
                            }
                        })
                } else {
                    self.setFormData({error: 'No API Specified'}, action)
                }
            },
            closeForm () {
                this.actionForm = {}
                this.actionFormModel = null
                this.actionFormFields = null

                this.formOpen = false

                if (this.clearOnSubmit) {
                    this.$emit('data:remove', this.actionFormSuccess)
                    this.selected = this.selected.filter(item => this.actionFormSuccess.indexOf(item) < 0)
                }

                this.actionFormSuccess = []
            },
            submitForm (e) {
                e.preventDefault()

                if (this.actionForm === {}) {
                    return
                }
                const self = this

                return this.$refs.bulkActionForm.validate()
                    .then(function () {
                        if (!self.actionForm.$valid) {
                            return
                        }

                        self.actionFormLoaded = false
                        if (self.actionFormSubmitApi !== undefined && self.actionFormSubmitApi !== self) {
                            let data = {
                                operation: self.actionFormOperation,
                                objects: JSON.stringify(self.selected),
                                params: JSON.stringify(self.actionFormModel)
                            }

                            return axios.post(self.actionFormSubmitApi, querystring.stringify(data), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                                .then(function (response) {
                                    if (response.data === undefined || response.data === null) {
                                        response.data = {}
                                    }

                                    if (!response.data.result) {
                                        response.data.error = response.data.error || response.data.message || 'An unknown error has occurred'

                                        if (response.data.error === response.data.message) {
                                            response.data.message = null
                                        }

                                        self.setFormData(response.data, {label: self.actionFormTitle})
                                    } else {
                                        self.actionForm = {}
                                        self.actionFormModel = null
                                        self.actionFormFields = null

                                        self.setFormData(response.data, {label: self.actionFormTitle})

                                        if (
                                            (
                                                response.data.message === undefined ||
                                                response.data.message === null
                                            ) && (
                                                response.data.error === undefined ||
                                                response.data.error === null
                                            ) && (
                                                response.data.file === undefined ||
                                                response.data.file === null
                                            )
                                        ) {
                                            self.closeForm()
                                        }
                                    }
                                })
                                .catch((error) => {
                                    if (error instanceof Error) {
                                        self.setFormData({error: error.message || 'An unknown error has occurred'}, {label: self.actionFormTitle})
                                    }
                                })
                        } else {
                            self.setFormData({error: 'No Response API Specified'}, {label: self.actionFormTitle})
                        }
                    }, function (e) {})
            }
        },
        created () {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// BulkUpdate.vue?4a48c54a